export default __webpack_public_path__ + "static/media/TealRefquestionnaire.684f01dc.png";